export const SIDE_BAR = {
  ACTION_TYPES: {
    onTabClick: 'onTabClick'
  },

  TABS: [
    {
      index: 0,
      filterName: 'current',
      aliasName: 'WEB_DROPDOWN_SCORES_OVERVIEW'
    },
    {
      index: 1,
      filterName: 'results',
      aliasName: 'WEB_DROPDOWN_RESULTS'
    },
    {
      index: 2,
      filterName: 'fixtures',
      aliasName: 'WEB_DROPDOWN_FIXTURES'
    }
  ]
}